import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/illustrations/arrow-grow.svg")